export default customElements.define('w-progress-bar', class ProgressBar extends wealthify.CustomElementBaseClass {
    constructor() {
        const styleSelector = 'c-progress-bar';
        const config = {
            styleSelector,
            templateHTML: `
            <div data-root>
                <div class="${styleSelector}__container u-display__none--mobile" data-desktop>
                    <div class="${styleSelector}__step-line-container" data-stepscontainer>
                        <div class="${styleSelector}__step-line--complete" data-steplinecomplete></div>
                        <div class="${styleSelector}__step-line--incomplete" data-steplineincomplete></div>
                    </div>
                </div>
                <div class="${styleSelector}__container u-display__none--tablet u-display__none--desktop" data-mobile></div>
                <div class="${styleSelector}__title u-display__none--tablet u-display__none--desktop" data-title>
            </div>`,
            cacheDom: [ 'data-desktop', 'data-mobile', 'data-stepscontainer', 'data-steplinecomplete', 'data-steplineincomplete', 'data-title' ]
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(styleSelector);
            if (this.steps) {
                this._createStepLines(this._findWithAttr(this.steps, 'state', 'selected'));
            }
        };
    }

    static fullWidthLength = 3;
    static slimWidthClasses = 'u-size__width-desktop--max-50 u-margin__left-desktop--auto u-margin__right-desktop--auto';

    static get requiredProperties () {
        return ['label', 'titleprop'];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('steps', {
                type: wealthify.propTypes.Array(),
                validators: [wealthify.propValidators.ArrayObjectContainsKeys(this.requiredProperties)]
            }),
        ];
    }

    get propCallbacks() {
        return {steps: () => {
            this._createStepElements();

            this._createStepLines(this._findWithAttr(this.steps, 'state', 'selected'));

            Array.prototype.forEach.call(this.dom.stepFancyButton, (step, index) => {

                if (step.state === 'complete') {
                    const chip = this.dom.stepFancyButtonChip[index];

                    step.addEventListener('mouseenter', () => chip.hovered = true);
                    step.addEventListener('mouseleave', () => chip.hovered = false);
                }
            });

            if (this.steps.length < this.constructor.fullWidthLength) {
                this.className = `${this.className} ${this.constructor.slimWidthClasses}`;
            }
        }};
    }

    _createStepElements() {
        const indexOfSelected = this._findWithAttr(this.steps, 'state', 'selected');

        this._createDesktopSteps(indexOfSelected);
        this._createMobileSteps(indexOfSelected);
    }

    _addChipElement(fancyButton) {
        if (fancyButton.state === 'complete') {
            let chip = document.createElement('w-chip');

            chip.label = 'Edit';
            chip.iconleft = 'pencil';
            chip.clickable = true;
            chip.ariahidden = true;
            this.dom.stepFancyButtonChip.push(chip);

            fancyButton.appendChild(chip);
        }
    }

    _createDesktopSteps() {
        this.dom.stepFancyButton = [];
        this.dom.stepFancyButtonChip = [];

        this.steps.forEach((item) => {
            let fancyButton = document.createElement('w-fancy-button');
            
            // TODO - Remove when ariadisabled is used in all occurences (e.g. w-progress-bar)
            // disabledprop used to proxy aria-disabled functionality.
            if(item.disabledprop !== undefined) {
                fancyButton.ariadisabled = item.disabledprop;
            }

            for(let property in item){
                fancyButton[property] = item[property];
            }

            if (item.state === 'selected') {
                fancyButton.setAttribute('aria-current', 'step');
            }

            fancyButton.shape = 'diamondsmall';
            
            this._addChipElement(fancyButton);
            
            this.dom.desktop.appendChild(fancyButton);

            this.dom.stepFancyButton.push(fancyButton);
        });
    }

    _createMobileSteps(indexOfSelected) {
        this.steps.forEach((item) => {
            let pip = document.createElement('w-pip');

            if (item.disabledprop !== undefined) {
                pip.disabledprop = item.disabledprop;
            }

            if (item.onclickprop !== undefined) {
                pip.onclickprop = item.onclickprop;
            }

            if (item.state !== undefined) {
                pip.state = item.state;

                if (item.state === 'selected') {
                    pip.setAttribute('aria-current', 'step');
                }
            }

            if (item.titleprop !== undefined) {
                pip.label = item.titleprop;
            }

            this.dom.mobile.appendChild(pip);
        });
        
        this.dom.title.textContent = this.steps[indexOfSelected].titleprop;
    }

    _createStepLines(index) {
        const steps = this.dom.stepFancyButton;

        this.dom.stepscontainer.style.left = `${steps[0].offsetWidth / 2}px`;
        this.dom.stepscontainer.style.right = `${steps[steps.length - 1].offsetWidth / 2}px`;

        const numberOfSteps = this.steps.length - 1;
        const segmentWidth = 100 / numberOfSteps;

        const firstLineWidth = index * segmentWidth;

        this.dom.steplinecomplete.style.width = `${firstLineWidth}%`;
    }

    _findWithAttr(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
        
        return -1;
    }
});